module.exports = __webpack_public_path__ + "static/img/s1mple.f1e7868.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/s1mple.jpg
// module id = BNx1
// module chunks = 35